const STORAGE_KEY = 'oikos.backendTarget'

export const BACKEND_TARGETS = {
  development: 'development',
  production: 'production',
}

const URLS = {
  development: {
    oikos: process.env.REACT_APP_OIKOS_API_URL || 'https://oikoslab.ecoss.is/oikos/_oikos_api.php',
    segi: process.env.REACT_APP_SEGI_API_URL || 'https://oikoslab.ecoss.is/oikos/_api_timesheet2.php',
    powerapps: process.env.REACT_APP_POWERAPPS_API_URL || 'https://oikoslab.ecoss.is/oikos/_powerapp_api.php',
    endPoints1: process.env.REACT_APP_END_POINTS_1_URL || 'https://oikoslab.ecoss.is/oikos/end_points_1.php',
  },
  production: {
    oikos: process.env.REACT_APP_PROD_OIKOS_API_URL || 'https://oikos.ecoss.is/oikos/_oikos_api.php',
    segi: process.env.REACT_APP_PROD_SEGI_API_URL || 'https://oikos.ecoss.is/oikos/_api_timesheet2.php',
    powerapps: process.env.REACT_APP_PROD_POWERAPPS_API_URL || 'https://oikos.ecoss.is/oikos/_powerapp_api.php',
    endPoints1: process.env.REACT_APP_PROD_END_POINTS_1_URL || 'https://oikos.ecoss.is/oikos/end_points_1.php',
  },
}

export function isAdminUser(user) {
  return Number(user?.perm_id) === 1
}

export function getBackendTarget() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === BACKEND_TARGETS.production || stored === BACKEND_TARGETS.development) {
      return stored
    }
  } catch (e) {
    // ignore
  }
  return BACKEND_TARGETS.development
}

export function getBackendUrls() {
  return URLS[getBackendTarget()] || URLS.development
}

export function getOikosApiUrl() {
  return getBackendUrls().oikos
}

/** Quem não é perm_id 1 não pode ficar apontando para produção. */
export function enforceBackendForUser(user) {
  if (isAdminUser(user)) return
  if (getBackendTarget() === BACKEND_TARGETS.production) {
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch (e) {
      // ignore
    }
    window.location.reload()
  }
}

export function setBackendTarget(target) {
  const next = target === BACKEND_TARGETS.production
    ? BACKEND_TARGETS.production
    : BACKEND_TARGETS.development
  try {
    localStorage.setItem(STORAGE_KEY, next)
  } catch (e) {
    // ignore
  }
  window.location.reload()
}
